// export const LOGOUT = 'LOGOUT'

export const CORE_LOGIN_REQUEST = 'CORE_LOGIN_REQUEST'
export const CORE_LOGIN_SUCCESS = 'CORE_LOGIN_SUCCESS'
export const CORE_LOGIN_FAILURE = 'CORE_LOGIN_FAILURE'

export const CORE_LOAD_ROOMSTATUS_REQUEST = 'CORE_LOAD_ROOMSTATUS_REQUEST'
export const CORE_LOAD_ROOMSTATUS_SUCCESS = 'CORE_LOAD_ROOMSTATUS_SUCCESS'
export const CORE_LOAD_ROOMSTATUS_FAILURE = 'CORE_LOAD_ROOMSTATUS_FAILURE'

export const CORE_LOAD_EVENT_REQUEST = 'CORE_LOAD_EVENT_REQUEST'
export const CORE_LOAD_EVENT_SUCCESS = 'CORE_LOAD_EVENT_SUCCESS'
export const CORE_LOAD_EVENT_FAILURE = 'CORE_LOAD_EVENT_FAILURE'

export const CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST'
export const CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS'
export const CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE'




// WEBPACK FOOTER //
// ./src/display/types.js